import { Schema } from 'prosemirror-model';
import { schema as basicSchema } from 'prosemirror-schema-basic';
import { addListNodes } from 'prosemirror-schema-list';

import { imageNodeSchema } from './image.schema';
import { linkMarkSchema } from './link.schema';
import { take } from './utils';

const schemaWithListNodes = (_schema: Schema) => {
  return new Schema({
    nodes: addListNodes(_schema.spec.nodes as any, 'paragraph block*', 'block'),
    marks: _schema.spec.marks,
  });
};

export const schema = take(schemaWithListNodes(basicSchema))
  .extendNodes({ image: imageNodeSchema })
  .extendMarks({ link: linkMarkSchema }).schema;
